module.exports = __webpack_public_path__ + "static/media/seal_color.06891476.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/MT/seal_color.png
// module id = 1509
// module chunks = 0